<template>
  <PageLayout
    :page-title="categoryTitle"
    :breadcrumb="$t('nav.products')"
    breadcrumb-to="/product/"
    banner-key="product"
  >
    <div class="productDiv product-page">
      <div class="product-page__inner wrap">
        <header class="product-page__head">
          <h1 class="product-page__title">{{ categoryTitle }}</h1>
        </header>

        <ProductCategoryNav :active-slug="categorySlug" />

        <div class="product-page__body" v-if="products.length">
          <div class="product-tiles">
            <router-link
              v-for="p in products"
              :key="p.id"
              :to="'/product/' + (routeCategorySlug || categorySlug) + '/' + p.id + '.html'"
              class="product-tile"
            >
              <span class="product-tile__media">
                <img v-if="productImage(p)" :src="productImage(p)" :alt="p.productName">
              </span>
              <span class="product-tile__name">{{ $cleanBrand(p.productName) }}</span>
            </router-link>
          </div>
          <PagePagination
            :page="pageNum"
            :total="total"
            :page-size="pageSize"
            @change="onPageChange"
          />
        </div>
        <p v-else class="product-page__empty">{{ $t('common.noProducts') }}</p>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import ProductCategoryNav from '@/components/hirays/ProductCategoryNav.vue'
import PagePagination from '@/components/hirays/PagePagination.vue'
import { listProductCategory, listProduct } from '@/utils/http'
import { unwrapRows, resolveImageUrl } from '@/utils/content'
import { isSameProductSlug } from '@/constants/productSlugs'
import { DEFAULT_PAGE_SIZE, unwrapTotal, scrollToListTop } from '@/utils/pagination'

export default {
  components: { PageLayout, ProductCategoryNav, PagePagination },
  props: { categorySlug: { type: String, default: '' } },
  data() {
    return {
      categoryName: '',
      products: [],
      categoryId: null,
      routeCategorySlug: '',
      pageNum: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0
    }
  },
  computed: {
    categoryTitle() {
      if (this.categorySlug) {
        return this.$navLabel('productNav', this.categorySlug, this.categoryName || this.$t('nav.products'))
      }
      return this.categoryName || this.$t('nav.products')
    }
  },
  watch: {
    categorySlug: {
      immediate: true,
      handler() {
        this.pageNum = 1
        this.load()
      }
    }
  },
  methods: {
    reloadCmsData() {
      this.load()
    },
    async load() {
      if (!this.categorySlug) return
      try {
        const catRes = await listProductCategory({ status: 1, pageNum: 1, pageSize: 100 }, this.$i18n.locale)
        const cats = unwrapRows(catRes)
        const cat = cats.find(c => isSameProductSlug(c.categorySlug, this.categorySlug))
        if (cat) {
          this.categoryName = cat.categoryName
          this.categoryId = cat.id
          this.routeCategorySlug = cat.categorySlug
          const prodRes = await listProduct({
            status: 1,
            categoryId: cat.id,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }, this.$i18n.locale)
          this.products = unwrapRows(prodRes)
          this.total = unwrapTotal(prodRes) || this.products.length
          return
        }
      } catch (e) { /* keep empty */ }
      this.products = []
      this.total = 0
    },
    onPageChange(page) {
      this.pageNum = page
      this.load()
      scrollToListTop(this.$el.querySelector('.product-page__body') || this.$el)
    },
    productImage(p) {
      const url = (p.picUrl || '').split(',')[0] || ''
      return resolveImageUrl(url)
    }
  }
}
</script>
